import React from 'react'
import {ShippingAddress} from '../../../../DTO/MemberShippingAddressDTO'
import {MBContentBodyDivider} from '../../../Atoms/Dividers'
import {PIMStack} from '../../../Atoms/Layouts/Bases/PIMStack'
import {MemberNameConfirms} from '../MemberNameConfirms'
import {ShippingAddressConfirms} from './ShippingAddressConfirms'
import {ConfirmContent} from '../../../Molecules/BaseContentBlocks/ConfirmContent'

export const ShippingAddressConfirmContents: React.VFC<ShippingAddress> = (
  {
    familyName,
    firstName,
    familyNameKana,
    firstNameKana,
    postCode,
    addressPrefectureCode,
    addressCity,
    addressStreet,
    addressBuilding,
    phone,
  },
) => {
  return (
    <PIMStack
      spacing={'18px'}
      divider={<MBContentBodyDivider/>}
      showEndDivider
      testId={'confirm-shipping-address'}
    >
      <MemberNameConfirms
        familyName={familyName}
        firstName={firstName}
        familyNameKana={familyNameKana}
        firstNameKana={firstNameKana}
      />
      <ShippingAddressConfirms
        postCode={postCode}
        addressPrefectureCode={addressPrefectureCode}
        addressCity={addressCity}
        addressStreet={addressStreet}
        addressBuilding={addressBuilding}
      />
      <ConfirmContent
        label={'電話番号'} values={[phone]}
        testDataId={'confirm-content-phone'}
      />
    </PIMStack>
  )
}
